import { useEffect } from 'react';

export const useEmitPrepared = () => {
  useEffect(() => {
    window.parent.postMessage({action: 'prepared'}, '*');
  }, []);
};
